module.exports = __webpack_public_path__ + "img/namewyg.b85593d8.png";